import { DesiredPaymentInfo } from './desired-payment-info';

export class PaymentInfo {

    APR: number;
    AdjustedDownpayment: number;
    AdjustedPrice: number;
    AmountFinanced: number;
    BuyRate: number;
    ClassCode: number;
    ComputedTemplate?: string;
    ComputedTemplateName?: string;
    DealerCustomFicoMessage?: string;
    DesiredPaymentInfo: DesiredPaymentInfo;
    Discount?: number;
    DocFees?: number;
    DownPayment?: number;
    Hint?: number;
    IsAmountOk?: number;
    IsPreQualified?: boolean;
    IsStructureOk?: boolean;
    MonthlyPayment?: number;
    NetCheck?: number;
    StateTax?: number;
    TaxesAndFees?: number;
    Term?: number;
    Tier?: number;
    TitleFees?: number;
    TradeInAmount?: number;
    TurnDownMessage?: string;

}



// WEBPACK FOOTER //
// ./src/app/api/models/payment-info.ts